var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-btn",on:{"click":_vm.handleClick}},[(_vm.icon)?_c('svg-icon',{style:({fontSize:_vm.iconSize}),attrs:{"icon-class":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }